module.exports = __webpack_public_path__ + "img/full7-min.e438b421.png";